<template>

  <el-card
      :title="title"
      :style="{ height: 'auto' }"
      style="margin-top: 20px !important;height: 180px;min-height: 180px;"
  >
    <div class="tops">
      <div style="font-weight: 700;
font-size: 20px;
color: #333333;
line-height: 20px;">
        {{ title }}
      </div>
      <el-button
          @click="addFriend"
          slot="extra"
          v-if="extra === 'addfriend'"
          type="primary"
          link
      >{{ $t("common.friend.add") }}
      </el-button
      >
    </div>
    <div class="mainBox" slot="content">
      <div class="item fx-d-c fx-a-c" v-for="item in list" :key="item.icon">
        <div
            class="box fx-aj-c"
            :style="{ backgroundImage: `url(${item.icon})` }"
        ></div>
        <span class="content" style="margin: 8px 0 5px 0"
        >{{ item.name }}
          </span>
        <span
            class="number bold"
            :style="{ color: item.countRed ? 'red' : '#000' }"
        >{{ item.count }}</span
        >
      </div>
    </div>
  </el-card>
</template>

<script>
import {ElCard} from "element-plus";
import Card from "@/components/Card.vue";

export default {
  props: {
    title: String,
    list: {
      type: Array,
      default: () => [],
    },
    extra: String,
  },
  components: {
    ElCard,
    Card,
  },
  setup() {
    const addFriend = () => {
      // Assuming $EventEmitter is a global event emitter
      // Make sure to initialize it appropriately in your app
      $EventEmitter.emit("addFriend");
    };

    return {
      addFriend,
    };
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  color: #333;
}

.mainBox {
  display: flex;
  justify-content: space-between;
  word-break: break-word;
  text-align: center;
  margin-top: 20px;
}

.item {
  width: 118px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.box {
  width: 32px;
  height: 32px;
  background-size: 32px 32px;
  background-repeat: no-repeat;
  margin: 0 auto;
}

.content,
.number {
  line-height: 1;
}

.content {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.number {
  margin-top: 10px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 26px;
}

.tops {
  display: flex;
  justify-content: space-between;
}

:deep(.el-card__body) {
  min-width: 358px !important;
  padding: 15px !important;
}

.bold {
  font-weight: 700;
}
</style>
